import { useEffect, useState } from "react";
import SimpleListbox, { SimpleOption } from "./input/SimpleListbox";
import { GradeModel, useGetGradesQuery } from "../features/lookup/lookupApiSlice";

export default function GradeSelector(props: {
	grade?: GradeModel;
	className: string;
	onChange: (grade: GradeModel) => void;
}) {
	const [gradeOptions, setGradeOptions] = useState<SimpleOption[]>([]);

	const gradesResult = useGetGradesQuery();
	const grades = gradesResult.data;

	const lookup = (value: number | string) => grades?.find((g) => g.gradeId == value);

	useEffect(() => {
		const options: SimpleOption[] = [];
		if (grades) {
			grades.map((grade) => {
				options.push({ value: grade.gradeId, label: grade.name });
			});
			setGradeOptions(options);
		}
	}, [grades]);

	const handleChange = (value: number | string) => {
		props.onChange(lookup(value)!);
	};

	return (
		<SimpleListbox
			id="gradeFilter"
			options={gradeOptions}
			prompt="Pick a grade..."
			value={props.grade?.gradeId}
			className={`${props.className}`}
			onChange={(e) => handleChange(e.target.value)}
		/>
	);
}
